// extracted by mini-css-extract-plugin
export default {"sliderContainer":"scenario-analysis_sliderContainer__pNMSg","label":"scenario-analysis_label__DZTKC"};